import { useQuery } from "@tanstack/react-query";
import { InterventionTableQuery } from "./models";
import { getTableQueryKey } from "../../helpers/tableHelpers";
import interventionsClient from "../../api/private/interventionsClient";
import { TableResultCPIntervention } from "../../api/models/unified";

const interventionsKey = "interventionsKey";

export const useGetInterventionsQuery = (params: InterventionTableQuery) => {
  return useQuery<TableResultCPIntervention>({
    queryKey: getTableQueryKey(interventionsKey, params),
    queryFn: () => interventionsClient.getInterventions(params),
  });
};
